import FlowerTitle from "../components/ui/FlowerTitle";
import StrokeTitle from "../components/ui/StrokeTitle";
import ReactPlayer from "react-player";

const Media = () => (
  <div className="page-container">
    <FlowerTitle text="Galerie"/>
    <StrokeTitle text="Tout est permis"/>
    <div className="video-container">
      <div className="video-wrapper">
        <ReactPlayer url="https://youtu.be/cGPX50LN0EI"/>
      </div>
    </div>
    <StrokeTitle text="Bande-annonce"/>
    <div className="video-container">
      <div className="video-wrapper">
        <ReactPlayer url="https://youtu.be/8xnit7IbIZ8"/>
      </div>
    </div>
  </div>
)


export default Media;